var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('login-form',{attrs:{"help":"/login/password-forgot"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }